import gql from 'graphql-tag'

const query = gql`
query listClosings($filter: closingsFilterArgs, $params: ListQueryArgs) {
	cashAssist {
		listClosings(filter: $filter, params: $params) {
			total
			totalAmount
			hasNextPage
    		items {
				id
				total
				dateTime
				number
				inactive
				cashRegister {
					id
					name
				}
				salesGroups {
					id
					amount
					total
					mWStNormal
					mWStReduced
					mWStFree
					mWStSpecial
					discount
					reduction
					salesGroup {
						id
						name
						acountNum
					}
				}
				users {
					id
					user {
						id
						name
						code
					}
					total
					clientCount
					averageBill
					userEfficiency
					cancellationsCount
					cancellationsAmount
					buttonOpenCount
					buttonBackCount
					buttonDelCount
					buttonDelAmount
					inCafeCount
					inCafeAmount
					inCafePercent
					tipsTotal
				}
	    	}
		}
	}
}`

export default query
